var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"menu-s-inscrire"},[_c('router-link',{attrs:{"to":{ name: 'SignUpColocSelect' },"title":"S'inscrire à COOLOC et créer un compte"}},[_c('svgicon',{staticClass:"signup-icon",attrs:{"icon":"signup"}}),_vm._v(" "),_c('span',[_vm._v("S’inscrire")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }